interface RGB {
  b: number;
  g: number;
  r: number;
}

interface SmartColors {
  color: any;
  background: any;
}

const rgbToYIQ = ({ r, g, b }: RGB) => {
  return (r * 299 + g * 587 + b * 114) / 1000;
};

const hexToRgb = (hex: string) => {
  if (!hex || hex === undefined || hex === "") {
    return undefined;
  }

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : undefined;
};

const contrast = (colorHex: string, threshold = 128) => {
  if (colorHex === undefined) {
    return "#000";
  }

  const rgb = hexToRgb(colorHex);

  if (rgb === undefined) {
    return "#000";
  }

  return rgbToYIQ(rgb) >= threshold ? "#000" : "#fff";
};

const componentToHex = (c: any) => {
  var hex = c.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
};

const rgbToHex = (r: any, g: any, b: any) => {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
};

export const smartColors = (): SmartColors => {
  const x = Math.floor(Math.random() * 256);
  const y = Math.floor(Math.random() * 256);
  const z = Math.floor(Math.random() * 256);

  const x2 = Math.floor(Math.random() * 256);
  const y2 = Math.floor(Math.random() * 256);
  const z2 = Math.floor(Math.random() * 256);

  const hex = rgbToHex(x, y, z);
  const color = contrast(hex);
  const direction = 135;

  return {
    color,
    background: `linear-gradient(${direction}deg, rgb(${x},${y},${z}), rgb(${x2},${y2},${z2}))`,
  };
};
